import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { Image } from 'components/core/Image';

import './FeaturedContentCard.scss';

const FeaturedContentCard = ({ item }) => {
	return (
		<Link
			href={item.url}
			target="_blank"
			rel="noreferrer noopener"
		>
			<div className="featured-card">
				<div className="featured-card__image-container">
					<Image
						src={item.image}
						alt={item.title}
						className="featured-card__image"
					/>
				</div>
				<div className="featured-card__content">
					<Paragraph color="priceBlue">{item.title}</Paragraph>
					<Paragraph>{item.content}</Paragraph>
					<Paragraph className="date">{item.date}</Paragraph>
				</div>
			</div>
		</Link>
	);
};

FeaturedContentCard.propTypes = {
	item: PropTypes.shape({
		title: PropTypes.string.isRequired,
		content: PropTypes.string,
		date: PropTypes.string,
		url: PropTypes.string,
		image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}).isRequired,
};

export default FeaturedContentCard;
